(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-quiz-popup"] && !Shopify.designMode) return;
  try {
    
/* custom-quiz-popup */
document.addEventListener('DOMContentLoaded', () => {
  // document.querySelector('.quiz-popup').addEventListener('click', (event)=>{
  //   const target = event.target  
  //   let has_closest = false
  //   if( document.body.classList.contains('popup-open') ){
  //     if( target.closest('.quiz-popup-wrapper') != null){ has_closest = true;}
  //     else if( target.closest('.quiz-card') != null ){  has_closest = true; }
     
  //     if( target.closest('.close-button') != null || target.classList.contains('close-button')  ){
  //       document.body.classList.remove('popup-open')
  //     }
  //     if(!has_closest){
  //       document.body.classList.remove('popup-open')
  //     }
  //   }
  // });
  document.querySelectorAll('.quiz-card').forEach(function(quiz_card_ele){
    quiz_card_ele.addEventListener('click', (event)=>{
      event.preventDefault();
      setTimeout(() => {
        const data_text = quiz_card_ele.dataset.text
        console.log('lastQuizController', lastQuizController)        
        const skip_button = document.querySelector('.octane-ai-quiz-rendered [data-element*="oct-quiz-skip-btn"] .oct-quiz-btn');
        skip_button && skip_button.dispatchEvent(new Event('click', { bubbles: true }))      
        const timeOut = skip_button ? 1000 : 0;
        setTimeout(() => {          
          document.querySelectorAll('.octane-ai-quiz-rendered .oct-quiz-multiple-choice-options .oct-quiz-multiple-choice-options__option').forEach(function (li_ele) {
            const text = li_ele.innerText.trim() || li_ele.textContent.trim();
            if( text == data_text ){
              li_ele.dispatchEvent(new Event('click', { bubbles: true }))
              document.querySelector('.octane-ai-quiz-rendered [data-element*="oct-quiz-submit-btn"] .oct-quiz-btn').dispatchEvent(new Event('click', { bubbles: true }))
            }
          })
          document.body.classList.add('popup-open')
        }, timeOut);
      });
    })
  })
});
/* custom-quiz-popup */  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-quiz"] && !Shopify.designMode) return;
  try {
    
  /* custom-quiz */
  document.addEventListener('DOMContentLoaded', () => {
    if (Shopify.designMode) {
      document.querySelector('.custom_octane-ai-quiz').classList.remove('hidden');
    }
    document.querySelector('.title_banner_wrapper .custom_button') && (
      document.querySelector('.title_banner_wrapper .custom_button').addEventListener('click', (event) =>{        
        const target = event.target
        event.preventDefault();
        target.closest('.shopify-section').classList.add('hidden')        
        document.querySelector('.custom_octane-ai-quiz').classList.remove('hidden');
        var maxHeight = 0
        document.querySelectorAll('.shopify-section-group-header-group').forEach((ele)=>{
          maxHeight = maxHeight + ele.offsetHeight
        })
        document.querySelector('.custom_octane-ai-quiz').style.minHeight = (window.innerHeight - maxHeight)+'px';
      })
    )
  });
  /* custom-quiz */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-grid-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const allWrappers   = Array.from(document.querySelectorAll('.video-wrapper'));
  const childWrappers = allWrappers.filter(w => w.closest('.child-grid'));
  let lastY = window.pageYOffset;
  const vh = () => window.innerHeight;
  function getActiveVideo(wrapper) {
    return Array.from(wrapper.querySelectorAll('video.video-element'))
      .find(v => getComputedStyle(v).display !== 'none');
  }

  // Setup child-grid videos
  childWrappers.forEach(wrapper => {
    const video = getActiveVideo(wrapper);
    if (!video) return;
    video.muted = true;
    wrapper.__hasAutoPlayed = false;
  });

  function updatePlayIcons(wrapper, isPlaying) {
    const playI  = wrapper.querySelector('.icon-play');
    const pauseI = wrapper.querySelector('.icon-pause');
    if (!playI || !pauseI) return;
    playI.style.display  = isPlaying ? 'none' : 'block';
    pauseI.style.display = isPlaying ? 'block' : 'none';
  }
  function updateMuteIcons(wrapper, isMuted) {
    const muted   = wrapper.querySelector('.icon-muted');
    const unmuted = wrapper.querySelector('.icon-unmuted');
    const btn     = wrapper.querySelector('button.mute-button');
    if (!muted || !unmuted || !btn) return;
    muted.style.display   = isMuted   ? 'block' : 'none';
    unmuted.style.display = isMuted   ? 'none'  : 'block';
    btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  // Manual play/pause + remove poster
  allWrappers.forEach(wrapper => {
    const playBtn = wrapper.querySelector('button.play-button');
    const isChild = childWrappers.includes(wrapper);

    playBtn.addEventListener('click', e => {
      e.stopPropagation();
      const video = getActiveVideo(wrapper);
      if (!video) return;

      if (video.paused) {
        if (isChild) video.muted = false;
        video.removeAttribute('poster');
        video.play();
        wrapper.classList.add('playing');
        updatePlayIcons(wrapper, true);
      } else {
        video.pause();
        wrapper.classList.remove('playing');
        updatePlayIcons(wrapper, false);
      }
    });

    if (isChild) {
      const muteBtn = wrapper.querySelector('button.mute-button');
      const video   = getActiveVideo(wrapper);
      updateMuteIcons(wrapper, video.muted);
      muteBtn.addEventListener('click', e => {
        e.stopPropagation();
        video.muted = !video.muted;
        updateMuteIcons(wrapper, video.muted);
      });
    }
    wrapper.querySelectorAll('video.video-element').forEach(video => {
      video.addEventListener('ended', () => {
        wrapper.classList.remove('playing');
        updatePlayIcons(wrapper, false);
        video.currentTime = 0;
      });
    });
  });

  // Scroll-down auto-play once at 40%
  function onScroll() {
    const y   = window.pageYOffset;
    const down = y > lastY;
    lastY = y;
    if (!down) return;

    const threshold = vh() * -0.2;
    childWrappers.forEach(wrapper => {
      const video = getActiveVideo(wrapper);
      if (!video || wrapper.__hasAutoPlayed) return;
      const top = wrapper.getBoundingClientRect().top;
      if (top <= threshold) {
        video.removeAttribute('poster');
        video.play();
        wrapper.classList.add('playing');
        updatePlayIcons(wrapper, true);
        wrapper.__hasAutoPlayed = true;
      }
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      document.documentElement.style.setProperty('--scroll-bar-width', `${window.innerWidth - document.body.offsetWidth}px`);      

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      let header_height = 0, header_height_update = 0; /*this.header.offsetHeight*/
      document.querySelectorAll('.shopify-section-group-header-group').forEach((he_ele)=>{        
        header_height += he_ele.offsetHeight;
        header_height_update += he_ele.offsetHeight;
        if( he_ele.classList.contains('scrolled-past-header') ){
          header_height_update = he_ele.offsetHeight;
        }
      })
      document.documentElement.style.setProperty('--header-height-total', `${ header_height}px`);
      document.documentElement.style.setProperty('--header-height-update', `${header_height_update}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight()
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight()
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.setHeaderHeight()
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
